
export class AddShuttleTransferContext {
    public routeTo: string[] = []
    public nextTo: string = ""

    constructor() { }
} 